<template>
    <div name="improvement" class="improvement">
        <post
            v-if="isPost"
            @onClose="closePost"
            @onSubmit="submitUncomfortable"
        />
        <improvement-banner 
            @postUncomfortable="postUncomfortable"
        />
        <improvement-list />
    </div>
</template>

<script>
import ImprovementList from '@/components/organisms/m_uncomfortable/ImprovementList'
import ImprovementBanner from '@/components/molecules/m_uncomfortable/improvements/ImprovementBanner'
import Post from '@/components/organisms/m_uncomfortable/Post'
import Constant from '@/constant';
import {mapState} from 'vuex'
import CampaignAuth from '@/utilities/campaignAuth';

export default {
    name: 'improvement',
    computed: mapState(['vocPage', 'vocDiabetes', 'vocLoginKakaoToken']),
    data: function()
    {
        return {
            isPost: false
        }
    },
    components: {
        ImprovementBanner,
        ImprovementList,
        Post
    },
    mounted: function()
    {
        this.$store.commit(Constant.SET_VOC_LOGIN_KAKAO_TOKEN, {token: CampaignAuth.getToken()});

        if(this.$route.query.ispost === "true")
        {
            this.$router.push('/m/campaign/improvement');
            this.isPost = true;
            // post open
        }
    },
    methods: {
        postUncomfortable: function()
        {
            const token = CampaignAuth.getToken()
            this.$store.commit(Constant.SET_VOC_LOGIN_KAKAO_TOKEN, {token: token});
            if(token === null)
            {
                this.login();
            } else {
                //open 
                this.isPost = true;
            }
            // 유효한 카카오 토큰이 있는지 확인

        },
        login: function()
        {
            CampaignAuth.login(`/m/campaign/improvement?ispost=true`);
        },
        closePost: function()
        {
            this.isPost = false;
        },
        submitUncomfortable: function(yearCount, contents)
        {
            this.isPost = false;
            this.$router.push({path: '/m/campaign/ranking'})
        }
    }
}
</script>

<style scoped>
    .improvement {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: flex-start;
        flex-direction: column;
        box-sizing: border-box;
        padding: 88px 20px 40px 20px;
        background: linear-gradient(90deg, rgba(192, 212, 237, 0.50) 0.11%, rgba(255, 255, 255, 0.50) 183.85%);
    }
</style>


// WEBPACK FOOTER //
// src/page/m_uncomfortable/Improvement.vue